import type { SVGProps } from 'react';

const SvgNaverColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.178 2H7.832C4.205 2 2.044 4.17 2.044 7.81v8.37c0 3.65 2.161 5.82 5.787 5.82h8.338c3.625 0 5.787-2.17 5.787-5.81V7.81C21.966 4.17 19.804 2 16.179 2Z'
      fill='#EFF0F3'
    />
    <path
      d='m13.382 12.264-2.78-4.014H8.296v7.5h2.414v-4.014l2.78 4.014h2.306v-7.5h-2.415v4.014Z'
      fill='#03C75A'
    />
  </svg>
);
export default SvgNaverColor;
